import { render, staticRenderFns } from "./ModalThirds.vue?vue&type=template&id=365b2cc9&"
import script from "./ModalThirds.vue?vue&type=script&lang=js&"
export * from "./ModalThirds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports